import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RouterModule } from "@angular/router";
import { WebAppSharedModule } from "../../shared";
import { TranslatePipeModule } from "../../../language/language.module";
import {
  ItemService,
  ItemPopupService,
  ItemEditComponent,
  clientManagementRoute,
  ItemResolvePagingParams
} from "./";

const ENTITY_STATES = [
  // ...clientManagementRoute,
];

@NgModule({
  imports: [
    WebAppSharedModule,
    TranslatePipeModule,
    RouterModule.forRoot(ENTITY_STATES, { useHash: true })
  ],
  declarations: [ItemEditComponent],
  entryComponents: [],
  providers: [ItemService, ItemPopupService, ItemResolvePagingParams],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebAppItemModule {}
